<template>
  <div class="chart" :style="{ height: height, width: width }"></div>
</template>

<script>
//import { echarts } from "echarts";
import * as echarts from "echarts";
import { runInThisContext } from "vm";
require("echarts/theme/shine"); // echarts theme

const tradingVolumeData = require("../../data/trading/tradingVolumeData.json");

export default {
  props: [
    "meter",
    "current",
    "vectors",
    "contract",
    "projectedConsumption",
    "offer",
    "req",
  ],
  data() {
    return {
      chart: null,
      sidebarElm: null,
      height: "650px",
      width: "100%",
      autoResize: true,

      tradingVolume: [],
      totalRequests: 0,
      totalOffers: 0,
      test: [],
      start: [],
    };
  },
  mounted() {
    this.start = new Array(this.req.length).fill(0);
    for (let o of this.offer) {
      const index = this.req.find((r) => r.requestCode === o.requestCode);
      this.start[index] = this.start[index] + o.volume;
    }
    this.initChart("BGDSO01", "073", "2021");
    if (this.autoResize) {
      this.__resizeHandler = this.debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener("resize", this.__resizeHandler);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.__resizeHandler);
    }
    this.sidebarElm &&
      this.sidebarElm.removeEventListener(
        "transitionend",
        this.sidebarResizeHandler
      );
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === "width") {
        this.__resizeHandler();
      }
    },
    setOptions() {
      let config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function () {
          var labelOption = {
            normal: {
              rotate: config.rotate,
              align: config.align,
              verticalAlign: config.verticalAlign,
              position: config.position,
              distance: config.distance,
            },
          };
          myChart.setOption({
            series: [
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
            ],
          });
        },
      };
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["Requests", "Accepted offers"],
        },
        toolbox: {
          show: false,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: true },
            data: this.req.map((a) => `${a.dateFrom} to ${a.dateTo}`),
            axisLabel: {
              interval: 0,
              fontSize: 10,
              rotate: 30, //If the label names are too long you can manage this by rotating the label.
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "Requests",
            type: "bar",
            barGap: 0,
            emphasis: {
              focus: "series",
            },
            itemStyle: { color: "#263858" },
            //data: [320, 332, 301, 334],
            data: this.req.map((a) => a.volume),
          },
          {
            name: "Accepted offers",
            type: "bar",
            emphasis: {
              focus: "series",
            },
            itemStyle: { color: "#34c16c" },
            //data: [220, 182, 191, 234],
            data: this.start,
          },
        ],
      });
    },
    initChart(zoneCode, locationCode, yearCode) {
      this.chart = echarts.init(this.$el, "shine");
      this.setOptions();
    },
    debounce(func, wait, immediate) {
      let timeout, args, context, timestamp, result;
      const later = function () {
        // According to the last trigger interval
        const last = new Date().getTime() - timestamp;
        // The last time the wrapped function was called, the interval is last less than the set time interval wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          // If it is set to immediate===true, since the start boundary has already been called, there is no need to call it here.
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) {
              context = args = null;
            }
          }
        }
      };
      return function (...args) {
        context = this;
        timestamp = new Date().getTime();
        const callNow = immediate && !timeout;
        // If the delay does not exist, reset the delay
        if (!timeout) {
          timeout = setTimeout(later, wait);
        }
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }
        return result;
      };
    },

    getTradingVolumeData(zoneCode, locationCode, yearCode) {
      //console.log("HERE... consumptions data: " + consumptionsData.toString());
      this.tradingVolume = [];
      this.totalRequests = 0;
      this.totalOffers = 0;

      for (var i = 0; i < tradingVolumeData.length; i++) {
        if (
          tradingVolumeData[i].zoneCode == zoneCode &&
          tradingVolumeData[i].locationCode == locationCode &&
          tradingVolumeData[i].yearCode == yearCode
        ) {
          this.tradingVolume.push(tradingVolumeData[i].tradingVolume);
        }
      }

      console.log(
        "HERE... trading volume data: " + this.tradingVolume.toString(),
        "length: " + this.tradingVolume[0].length
      );

      for (var i = 0; i < this.tradingVolume[0].length; i++) {
        this.totalRequests =
          this.totalRequests + this.tradingVolume[0][i].totalRequests;
        this.totalOffers =
          this.totalOffers + this.tradingVolume[0][i].totalOffers;
      }

      console.log(
        "HERE... totalRequests: " +
          this.totalRequests +
          " totalOffers: " +
          this.totalOffers
      );
    },
  },

  updated() {
    // Fired every second, should always be true
    this.tradingVolume;
    console.log(
      "HERE... trading volume data: " + this.tradingVolume.toString()
    );
  },
};
</script>

<style lang="scss">
.chart-filter {
  position: absolute;
  top: 30px;
  left: 200px;
  font-size: 30px;
}
</style>